export const workspaceAgentPath = (
  campaignId: string,
  agentId = 'new',
  jobId?: string,
  setupId?: string,
) => {
  const query = new URLSearchParams();
  if (jobId) query.set('job', jobId);
  if (setupId) query.set('setup', setupId);
  return `/workspace/campaign/${encodeURIComponent(campaignId)}/agents/${encodeURIComponent(agentId)}${query.size ? `?${query}` : ''}`;
};
